import { useRef, useState } from "react";
import { Upload, X, Star, Plus } from "lucide-react";
import ImageCropDialog from "./ImageCropDialog";

/** Multi-image editor: drag & drop zone + file picker, crop before add, remove, set primary. value = string[] */
export default function ImageGalleryEditor({ value = [], onChange, testid = "gallery" }) {
  const [queue, setQueue] = useState([]);
  const [over, setOver] = useState(false);
  const input = useRef(null);
  const images = value || [];
  const addFiles = (list) => { const files = Array.from(list || []).filter((f) => f.type.startsWith("image/")); if (files.length) setQueue(files); };
  const onDrop = (e) => { e.preventDefault(); setOver(false); addFiles(e.dataTransfer.files); };
  return (
    <div data-testid={`${testid}-editor`}>
      <div className="flex flex-wrap gap-2">
        {images.map((src, i) => (
          <div key={i} data-testid={`${testid}-image-${i}`} className="group relative h-20 w-20 overflow-hidden rounded-lg border border-slate-200 bg-white">
            <img src={src} alt="" className="h-full w-full object-contain" />
            {i === 0 && <span className="absolute left-1 top-1 rounded bg-[#D46117] px-1 text-[9px] font-bold text-white">MAIN</span>}
            <div className="absolute inset-x-0 bottom-0 flex justify-between bg-black/50 p-0.5 opacity-0 transition group-hover:opacity-100">
              {i > 0 ? <button type="button" data-testid={`${testid}-primary-${i}`} title="Make main" onClick={() => onChange([src, ...images.filter((_, j) => j !== i)])} className="text-white"><Star className="h-3.5 w-3.5" /></button> : <span />}
              <button type="button" data-testid={`${testid}-remove-${i}`} title="Remove" onClick={() => onChange(images.filter((_, j) => j !== i))} className="text-white"><X className="h-3.5 w-3.5" /></button>
            </div>
          </div>
        ))}
        <button type="button" data-testid={`${testid}-dropzone`} onClick={() => input.current?.click()} onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)} onDrop={onDrop}
          className={`flex h-20 min-w-[7rem] flex-1 flex-col items-center justify-center rounded-lg border-2 border-dashed text-[11px] font-semibold transition ${over ? "border-[#D46117] bg-[#FBEEF4] text-[#D46117]" : "border-slate-300 text-[#28282E]/60 hover:border-[#EBBAD1]"}`}>
          {over ? <Upload className="h-5 w-5" /> : <Plus className="h-5 w-5" />}
          {over ? "Drop to add" : "Drag & drop or click"}
        </button>
        <input ref={input} type="file" accept="image/*" multiple hidden data-testid={`${testid}-file-input`} onChange={(e) => { addFiles(e.target.files); e.target.value = ""; }} />
      </div>
      {queue.length > 0 && <ImageCropDialog files={queue} onDone={(dataUrl) => onChange([...(value || []), dataUrl])} onCancel={() => setQueue([])} />}
    </div>
  );
}
